export const home = {
  name: 'Home',
  strapline: 'Be inspired to make home improvements',
  frequency: 'monthly',
  code: 'hme',
  salesforceName: 'home',
}

export const tech = {
  name: 'Tech',
  strapline: "News, deals and stuff the manuals don't tell you",
  frequency: 'monthly',
  code: 'tec',
  salesforceName: 'tech_support',
}

export const foodAndHealth = {
  name: 'Food & Health',
  strapline: 'Live well and stay healthy',
  code: 'fah',
  frequency: 'monthly',
  salesforceName: 'food_and_health',
}

export const weeklyScoop = {
  name: 'Weekly Scoop',
  strapline: 'Top tips for making smarter consumer choices',
  frequency: 'weekly',
  code: 'scp',
  salesforceName: 'weekly_scoop',
}

export const gardening = {
  name: 'Gardening',
  strapline: 'Breathe new life into your outside spaces',
  frequency: 'monthly',
  code: 'gdn',
  salesforceName: 'gardening',
}

export const deals = {
  name: 'Deals',
  strapline: 'Grab genuine bargains using our expert tips',
  frequency: 'monthly',
  code: 'dea',
  salesforceName: 'deals',
}

export const cars = {
  name: 'Cars',
  strapline: 'Drive smarter and cut your costs',
  frequency: 'monthly',
  code: 'crs',
  salesforceName: 'cars',
}

export const money = {
  name: 'Money',
  strapline: 'Be more savvy with how you manage your finances',
  frequency: 'weekly',
  code: 'mny',
  salesforceName: 'money',
}

export const travel = {
  name: 'Travel',
  strapline: 'Plan better holidays, starting now',
  code: 'tvl',
  frequency: 'monthly',
  salesforceName: 'travel',
}

export const sustainability = {
  name: 'Sustainability',
  strapline: 'Make changes for the planet and your pocket',
  code: 'sus',
  frequency: 'monthly',
  salesforceName: 'sustainability',
}

export const scamAlerts = {
  name: 'Scam Alerts',
  strapline: 'Outsmart the fraudsters',
  code: 'scm',
  frequency: 'weekly',
  salesforceName: 'scams',
}

export const retirement = {
  name: 'Retirement',
  strapline: 'Make the right retirement choices',
  code: 'rin',
  frequency: '8 part series',
  salesforceName: 'retirement_income',
}

export const newslettersOrderedByPopularity: NewsletterData[] = [
  home,
  tech,
  foodAndHealth,
  weeklyScoop,
  gardening,
  deals,
  cars,
  money,
  travel,
  sustainability,
  scamAlerts,
  retirement,
]

export const newsletterSfNameMap = new Map(
  newslettersOrderedByPopularity.map((newsletter) => [newsletter.salesforceName, newsletter])
)

export type NewsletterData = {
  name: string
  strapline: string
  frequency: string
  code: string
  salesforceName: string
}
